import React, { Component } from "react";
import withLocation from "../../../comps/withLocation";
import { apiUrl } from "../../../comps/apiUrl";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faFilePdf,
  faPen,
  faTrash,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { StaticDialog } from "react-st-modal";

class ClientView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      data: {},
      selectedFile: null,
      TrashFileDoc: {},
      see: {},
      error: false, // Added error state for better error handling
    };
    this.iptFile = React.createRef();
  }

  componentDidMount() {
    document.title = "Visualizar Cliente";
    this.fetchClientData();
  }

  fetchClientData = () => {
    fetch(`${apiUrl}/view-client/${this.props.params.token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === 404) {
          this.setState({
            loader: false,
            error: true,
          });
          return; // Stop execution if client not found
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          this.setState({
            data,
            loader: false,
          });
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados do cliente:", error);
        toast.error("Erro ao carregar dados do cliente.");
        this.setState({ loader: false, error: true });
      });
  };

  handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const allValid = files.every((file) => {
        const isImage = file.type.startsWith("image/");
        const isPDF = file.type === "application/pdf";
        return isImage || isPDF;
      });

      if (allValid) {
        this.setState({ selectedFile: files });
      } else {
        toast.error("Por favor, selecione apenas imagens ou arquivos PDF.");
        this.setState({ selectedFile: null });
        this.iptFile.current.value = null; // Clear input if invalid files
      }
    } else {
      this.setState({ selectedFile: null }); // Clear selectedFile if no files are chosen
    }
  };

  FormatDataBr(data) {
    if (!data) return "N/A"; // Handle null or undefined data
    const date = new Date(data);
    return (
      `${date.getDate().toString().padStart(2, "0")}/` +
      `${(date.getMonth() + 1).toString().padStart(2, "0")}/` +
      `${date.getFullYear()} ` +
      `${date.getHours().toString().padStart(2, "0")}:` +
      `${date.getMinutes().toString().padStart(2, "0")}:` +
      `${date.getSeconds().toString().padStart(2, "0")}`
    );
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (e.currentTarget) e.currentTarget.classList.add("load");

    if (!this.state.selectedFile || this.state.selectedFile.length === 0) {
      toast.error("Por favor, selecione ao menos um arquivo para upload.");
      if (e.currentTarget) e.currentTarget.classList.remove("load");
      return;
    }

    const formData = new FormData();
    this.state.selectedFile.forEach((file) => {
      formData.append(`images`, file); // Backend expects 'images' as key for multiple files
    });

    fetch(`${apiUrl}/client-upload-document/${this.props.params.token}`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (e.currentTarget) e.currentTarget.classList.remove("load");
        if (response.status === 200) {
          this.iptFile.current.value = null; // Clear the file input element
          this.setState({ selectedFile: null }); // Clear selected file state
          return response.json();
        } else {
          toast.error("Erro ao fazer upload do documento.");
          throw new Error("Failed to upload document"); // Propagate error
        }
      })
      .then((r) => {
        const newFiles = r.files.map((item) => ({
          ...item,
          fileName: item.fileName,
        }));

        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            files: [...prevState.data.files, ...newFiles], // Append new files to existing ones
          },
        }));
        toast.success("Documento(s) atualizado(s) com sucesso.");
      })
      .catch((error) => {
        console.error("Erro ao atualizar o documento:", error);
        toast.error("Erro ao atualizar o documento.");
      });
  };

  handleDeleteDocument = () => {
    const { TrashFileDoc } = this.state;
    if (!TrashFileDoc.id) return; // Ensure there's a document to delete

    // Optionally add a loading class to the delete button if needed
    // e.target.classList.add("load");

    fetch(`${apiUrl}/delete-document`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({
        id: TrashFileDoc.id,
        token: this.props.params.token,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        // Remove loading class if added
        this.setState({ TrashFileDoc: {} }); // Close the dialog immediately
        if (data.error) {
          toast.error(data.error);
        } else {
          this.setState((prevState) => ({
            data: {
              ...prevState.data,
              files: prevState.data.files.filter(
                (doc) => doc.id !== TrashFileDoc.id
              ),
            },
          }));
          toast.success("Documento excluído com sucesso!");
        }
      })
      .catch((error) => {
        console.error("Erro ao excluir documento:", error);
        toast.error("Erro ao excluir documento.");
        this.setState({ TrashFileDoc: {} }); // Ensure dialog closes on error
      });
  };

  TypeBlock(type) {
    switch (type) {
      case 0:
        return "Desbloqueado";
      case 1:
        return "Bloqueado Para Locação";
      case 2:
        return "Bloqueado Para Serviço";
      case 3:
        return "Bloqueio Total";
      default:
        return "Desbloqueado"; // Default case for unexpected values
    }
  }

  // Helper function to render a field with a default "Não cadastrado" message
  renderField = (label, value) => (
    <p>
      <strong>{label}:</strong>{" "}
      {value && value !== "" ? (
        value
      ) : (
        <span className="text-danger"> Não cadastrado</span>
      )}
    </p>
  );

  render() {
    const { loader, data, TrashFileDoc, see, error } = this.state;

    if (loader) {
      return (
        <div className="area-loader">
          <div className="loader"></div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="content">
          <div className="alert alert-danger" role="alert">
            Erro ao carregar os dados do cliente ou cliente não encontrado.
          </div>
        </div>
      );
    }

    // Determine if the client is an individual (Pessoa Física) based on cnpj_cpf length
    // CPFs typically have 11 digits, CNPJs have 14 digits (before formatting)
    const isIndividual =
      data.cnpj_cpf && data.cnpj_cpf.replace(/\D/g, "").length === 11;

    return (
      <div className="content">
        <div className="card shadow-sm mb-4">
          <div className="card-header   d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Visualizar Cliente</h4>
          </div>
          <div className="card-body">
            {/* Client Status - Display for all client types */}
            <div className="mb-3">
              <p className="lead">
                <strong>Status do Cliente:</strong>{" "}
                <span
                  className={`badge bg-${
                    data.status === 0 ? "success" : "danger"
                  }`}
                >
                  {this.TypeBlock(data.status)}
                </span>
              </p>
            </div>

            {/* Documentos */}
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-light d-flex align-items-center justify-content-between">
                <h5 className="mb-0">Documentos</h5>
                <form
                  className="d-flex align-items-center"
                  onSubmit={this.handleSubmit}
                >
                  <input
                    type="file"
                    className="form-control form-control-sm me-2"
                    ref={this.iptFile}
                    multiple
                    onChange={this.handleFileChange}
                    accept="image/*,application/pdf"
                  />
                  <button
                    type="submit"
                    className="btn btn-success btn-sm"
                    disabled={
                      !this.state.selectedFile ||
                      this.state.selectedFile.length === 0
                    }
                  >
                    <FontAwesomeIcon icon={faUpload} className="me-1" /> Upload
                  </button>
                </form>
              </div>
              <div className="card-body">
                {data.files && data.files.length > 0 ? (
                  <div className="row g-3">
                    {data.files.map((item) => (
                      <div className="col-auto" key={item.id}>
                        <div className="card h-100" style={{ width: "120px" }}>
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ height: "90px", overflow: "hidden" }}
                          >
                            {item.fileName.split(".").pop() === "pdf" ? (
                              <FontAwesomeIcon
                                icon={faFilePdf}
                                size="4x"
                                className="text-danger"
                              />
                            ) : (
                              <img
                                src={`${apiUrl}/img/${item.fileName}`}
                                className="img-fluid"
                                alt="Document"
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                            )}
                          </div>
                          <div className="card-footer d-flex justify-content-around p-1">
                            {item.fileName.split(".").pop() === "pdf" ? (
                              <a
                                href={`${apiUrl}/img/${item.fileName}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary btn-sm"
                                title="Abrir PDF"
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </a>
                            ) : (
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => this.setState({ see: item })}
                                title="Visualizar Imagem"
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </button>
                            )}
                            <button
                              className="btn btn-danger btn-sm ms-1"
                              onClick={() =>
                                this.setState({ TrashFileDoc: item })
                              }
                              title="Excluir Documento"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="alert alert-info mb-0">
                    Nenhum documento cadastrado.
                  </div>
                )}
              </div>
            </div>

            {/* Histórico do Cliente */}
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-light">
                <h5 className="mb-0">Histórico do Cliente</h5>
              </div>
              <div className="card-body">
                {data.history && data.history.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Status</th>
                          <th>Observação</th>
                          <th>Data</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.history.map((item, index) => (
                          <tr key={index}>
                            <td>{this.TypeBlock(item.status)}</td>
                            <td>{item.obs}</td>
                            <td>{this.FormatDataBr(item.created_at)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-info mb-0">
                    Nenhum histórico disponível.
                  </div>
                )}
              </div>
            </div>

            {/* Informações do Cliente - Diferenciado por Tipo de Pessoa */}
            {isIndividual ? (
              <div className="card shadow-sm">
                <div className="card-header  ">
                  <h5 className="mb-0">Informações de Pessoa Física</h5>
                </div>
                <div className="card-body">
                  <h6 className="text-primary mt-3">Dados Pessoais</h6>
                  {this.renderField("Nome", data.nome)}
                  {this.renderField("CPF", data.cnpj_cpf)}
                  {this.renderField("RG", data.rg)}

                  <h6 className="text-primary mt-3">Contato</h6>
                  {this.renderField("Telefone Fixo", data.telefone)}
                  {this.renderField("Celular", data.celular)}
                  {this.renderField("Email", data.email)}

                  <h6 className="text-primary mt-3">Endereço</h6>
                  {this.renderField("Endereço", data.endereco)}
                  {this.renderField("Número", data.numero)}
                  {this.renderField("Bairro", data.bairro)}
                  {this.renderField("Cidade", data.cidade)}
                  {this.renderField("Estado", data.uf)}
                  {this.renderField("CEP", data.cep)}
                </div>
              </div>
            ) : (
              <div className="card shadow-sm">
                <div className="card-header ">
                  <h5 className="mb-0">Informações de Pessoa Jurídica</h5>
                </div>
                <div className="card-body">
                  <h6 className="text-primary mt-3">Dados da Empresa</h6>
                  {this.renderField("Razão Social", data.nome)}
                  {this.renderField("CNPJ", data.cnpj_cpf)}
                  {this.renderField(
                    "Inscrição Estadual",
                    data.inscricao_estadual
                  )}

                  <h6 className="text-primary mt-3">Contato</h6>
                  {this.renderField("Telefone Fixo", data.telefone)}
                  {this.renderField("Celular", data.celular)}
                  {this.renderField("Email", data.email)}

                  <h6 className="text-primary mt-3">Endereço</h6>
                  {this.renderField("Endereço", data.endereco)}
                  {this.renderField("Número", data.numero)}
                  {this.renderField("Bairro", data.bairro)}
                  {this.renderField("Cidade", data.cidade)}
                  {this.renderField("Estado", data.uf)}
                  {this.renderField("CEP", data.cep)}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Static Dialog for Image View */}
        <StaticDialog
          isOpen={Object.keys(see).length > 0}
          title="Visualizar Documento"
          onAfterClose={() => this.setState({ see: {} })}
        >
          {see.fileName && (
            <div className="d-flex justify-content-center align-items-center">
              <img
                src={`${apiUrl}/img/${see.fileName}`}
                alt="Documento"
                className="img-fluid"
                style={{ maxWidth: "100%", maxHeight: "80vh" }}
              />
            </div>
          )}
        </StaticDialog>

        {/* Static Dialog for Delete Confirmation */}
        <StaticDialog
          isOpen={Object.keys(TrashFileDoc).length > 0}
          title="Excluir Documento?"
          onAfterClose={() => this.setState({ TrashFileDoc: {} })}
        >
          <div className="text-center p-3">
            <p>Tem certeza que deseja excluir o documento?</p>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              className="btn btn-danger"
              onClick={this.handleDeleteDocument}
            >
              <FontAwesomeIcon icon={faTrash} className="me-2" /> Excluir
            </button>
            <button
              className="btn btn-secondary ms-2"
              onClick={() => this.setState({ TrashFileDoc: {} })}
            >
              Cancelar
            </button>
          </div>
        </StaticDialog>
      </div>
    );
  }
}

export default withLocation(ClientView);
